export const global_height_breakpoint_sm = {
  "name": "--pf-global--height-breakpoint--sm",
  "value": "0",
  "var": "var(--pf-global--height-breakpoint--sm)"
};
export default global_height_breakpoint_sm;